export const UserNotification = {
  list: function() {
    var options = {
      bDeferRender: true,
      data: JSON.parse(jQuery('#user-notification-data').html()),
      info: false,
      lengthChange: false,
      language: {
        searchPlaceholder: I18n.t('search')
      },
      pageLength: 20,
      autoWidth: false,
      initComplete: function () {
        DataTablesHelper.setAutoComplete(jQuery("#user-notifications"));
      },
      columnDefs: [
        {
          render: function (data, type, row) {
            if (type == 'display') {
              return jQuery('#user-notification-title-template').html().
              replace(/__status__/g, row[1]).
              replace(/__title__/g, data);
            }
            return data;
          },
          targets: [0]
        },
        {
          render: function (data, type, row, meta) {
            if (type == 'display') {
              return jQuery('#user-notification-status-template').html().
              replace(/__status__/g, data).
              replace(/__label__/g, I18n.t(data));
            }
            return data;
          },
          targets: [1]
        },
        {
          targets: [2],
          searchable: false,
          sortable: false,
        }
      ],
      drawCallback: function () {
        ActionJS.UserNotification.priv.bindEvent();
      },
      footerCallback: function () {
        DataTablesHelper.togglePagination(this);
      },
    };

    var table = jQuery('#user-notifications');
    table.DataTable(options);
  },

  priv: {
    bindEvent: function () {
      jQuery('.user-notification-actions')
        .off('click')
        .on("click", function (e) {
          e.stopPropagation();
          var c = true;
          if (jQuery(this).data('confirm')) {
            c = confirm(jQuery(this).data('confirm'));
          }
          if (c) {
            jQuery
              .ajax({
                url: jQuery(this).attr('href'),
                method: jQuery(this).attr('data-method'),
                headers: { "X-CSRF-Token": jQuery('meta[name="csrf-token"]').attr('content') },
              })
              .done(function (d) {
                $('.dt-container').html(SmartME.loadingIndicator());
                Turbo.visit(location.href, {action: 'replace'});
              })
              .fail(function (e) {
                alert((((e.responseJSON || {}).id || [])[0] || {}).message || I18n.t('unexpected_error'));
              });
          }
          e.preventDefault();
        });
    },
  }
};
